export default "__VITE_ASSET__eadjJx7G__"